export enum PickListEnum {
  SINGLE = 'Single',
  CONSOLIDATED = 'Consolidated',
}
